import MessageBroker from "@bonprix/pattern-library/components/message-broker";
import Messages from '../components/messages';
import Landmark from '../components/landmark-adapter';
import Trinity from '../components/trinity-adapter';
import Storage from '../components/storage';
import meta from '../helper/meta';

const trackingDisabled = meta.value('trackingDisabled') === 'true';

if (!trackingDisabled) {
    MessageBroker.subscribe(Messages.DOM.CHANGED, () => {
        const uninitializedLandmarkNodes = document.querySelectorAll('[jsh-landmark]');
        const uninitializedTrinityNodes = document.querySelectorAll('[jsh-trinity]');
        const uninitializedStorageNodes = document.querySelectorAll('[jsh-storage]');

        uninitializedLandmarkNodes.forEach((landmarkElement) => {
            Landmark.initialize(landmarkElement);
        });

        uninitializedTrinityNodes.forEach((landmarkElement) => {
            Trinity.initialize(landmarkElement);
        });

        uninitializedStorageNodes.forEach((storageElement) => {
            Storage.initialize(storageElement);
        });

        // Mark all handled landmarks as initialized
        uninitializedLandmarkNodes.forEach((uninitializedLandmarkNode) => {
            uninitializedLandmarkNode.setAttribute('jsh-landmark--initialized', '');
        });
        uninitializedLandmarkNodes.forEach((uninitializedLandmarkNode) => {
            uninitializedLandmarkNode.removeAttribute('jsh-landmark');
        });

        // Mark all handled landmarks as initialized
        uninitializedTrinityNodes.forEach((uninitializedLandmarkNode) => {
            uninitializedLandmarkNode.setAttribute('jsh-trinity--initialized', '');
        });
        uninitializedTrinityNodes.forEach((uninitializedLandmarkNode) => {
            uninitializedLandmarkNode.removeAttribute('jsh-trinity');
        });
    });

    MessageBroker.subscribe(Messages.WINDOW.ORIENTATION_CHANGED, () => {
        Landmark.sendUserInfoLandmark();
    });
}
